import React, { FC, ReactNode } from "react";

interface UseRadioProps {
	value?: string;
	isChecked?: boolean;
	isDisabled?: boolean;
	onChange?: (value: string) => void;
	name?: string;
}

interface Props extends UseRadioProps {
	children?: ReactNode;
	radioProps: UseRadioProps;
	ariaLabel: string;
}

const RadioCard: FC<Props> = ({ children, radioProps, ariaLabel }) => {
	const { value, isChecked, isDisabled, onChange, name } = radioProps;

	return (
		<label className="cursor-pointer">
			<input
				type="radio"
				value={value}
				checked={isChecked}
				disabled={isDisabled}
				onChange={() => onChange?.(value ?? "")}
				name={name}
				aria-label={ariaLabel}
				className="sr-only"
			/>

			<div
				className={`rounded cursor-pointer p-2 border transition-shadow ${
					isChecked
						? "border-foreground bg-white shadow-md"
						: "border-transparent bg-transparent hover:border-border hover:bg-white hover:shadow-md"
				}`}
			>
				{children}
			</div>
		</label>
	);
};

export default RadioCard;
